import { Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import React, { Fragment, useState, useCallback, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import HeadingCommon from "../../Common/Component/HeadingCommon";
import { DataTableHeading } from "../../Constant";
import { tableColumns } from "../../Data/DataTable/user";
import AddUser from "./AddUser";
// import axios from "axios";
import EditUser from "./EditUser";
import { ServerPath } from "../../Constant";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import cookieUtils from "../../utils/cookieUtils";
import greenEye from "../../assets/images/svg/eyegreen.svg";
import FilterDropdown from "../../Common/FilterDropdown";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { _axios } from "../../utils/axios";

const DataTablesContain = () => {
  const [users, setUsers] = useState([]);
  const [filterStatus, setFilterStatus] = useState("all");

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `${ServerPath}/users`;
        const response = await _axios.get(url);
        const actualData = response?.data?.data;

        // Filter data based on status
        let filteredData;
        switch (filterStatus) {
          case "all":
            filteredData = actualData;
            break;
          case "active":
            filteredData = actualData.filter((user) => user.status === "1");
            break;
          case "inactive":
            filteredData = actualData.filter((user) => user.status === "0");
            break;
          case "both":
            filteredData = actualData.filter(
              (user) => user.status === "1" || user.status === "0"
            );
            break;
          default:
            filteredData = actualData;
        }

        const userData = filteredData.map((user) => ({
          ...user,
          user_image: user.user_image ? (
            <img src={user.user_image} alt="picture" width="45" height="45" />
          ) : null,
          dateofbirth: formatDate(user.dateofbirth),
          lastModifiedOn: user.last_modified_on ? formatDate(user.last_modified_on): "-",
          dob: user.dateofbirth,
          action: getUserActionButtons(user),
        }));

        setUsers(userData.reverse());
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchData();
  }, [filterStatus]);

  const handleFilterChange = (status) => {
    console.log("Filter status changed to:", status);
    setFilterStatus(status);
  };

  // Tooltip component
  const renderTooltip = (props) => (
    <Tooltip
      className="custom-tooltip"
      {...props}
      // style={{
      //   backgroundColor: "#000",
      //   color: "#fff",
      //   // border: "none",
      //   // borderRadius: 0,
      //   // boxShadow: "none",
      // }}
    >
      Deactivate
    </Tooltip>
  );

  const getUserActionButtons = (user) => {
    const role = cookieUtils.getSecureCookie("role");
    console.log("User role from cookie:", role);
    return (
      <div className="action d-flex justify-content-center">
        <>
          <div
            className="edit"
            data-bs-toggle="modal"
            data-bs-target="#exampleModalCenter"
          >
            {user && <AddUser data={user} isEditButton={true} />}
          </div>
          <div className="delete">
            <OverlayTrigger
              placement="top" // You can change this to "bottom", "left", or "right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <Button
                onClick={(e) => handleDeleteID(user.user_id, e)}
                className="btn-square btn btn-danger mx-2"
              >
                <i className="icon-na"></i>
              </Button>
            </OverlayTrigger>
          </div>
        </>
      </div>
    );
  };

  const handleViewID = (userId, event) => {
    event.preventDefault();
    // Handle view functionality
  };

  const handleDeleteID = async (userId, event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, deactivate it!",
      cancelButtonText: "No, cancel!",
      customClass: {
        container: "swal2-container",
      },
    });

    if (result.isConfirmed) {
      try {
        await _axios.get(`${ServerPath}/users/deactivate/${userId}`);
        setUsers((prevUsers) =>
          prevUsers.filter((user) => user.user_id !== userId)
        );
        Swal.fire("Deactivated!", "Your user has been deactivated.", "success");
      } catch (error) {
        console.error("Error deactivating user:", error);
        Swal.fire(
          "Error!",
          "There was an error deactivating the user.",
          "error"
        );
      }
    }
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDeactivate = () => {
    if (
      window.confirm(
        `Are you sure you want to deactivate:\r ${selectedRows.map(
          (r) => r.title
        )}?`
      )
    ) {
      setToggleDelet(!toggleDelet);
      selectedRows.map(async (item) => {
        await _axios.get(`${ServerPath}/users/deactivate/${item?.user_id}`);
      });
      setUsers(
        users.filter((item) =>
          selectedRows.filter((elem) => elem.id === item.id).length > 0
            ? false
            : true
        )
      );
      setSelectedRows("");
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-6">
          <Breadcrumbs
            mainTitle="Mobile App User Lists"
            parent="Tables"
            title="User List"
          />
        </div>
        <div className="col-12 col-md-6 col-lg-6">
          <div className="d-flex justify-content-end align-items-center">
            <FilterDropdown onFilterChange={handleFilterChange} />
            {/* <button className="btn-square btn btn-primary mx-2">
            <i className="icon-filter"></i>
          </button> */}
            <AddUser isAddUser={true} />
          </div>
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="pt-0">
                {selectedRows.length !== 0 && (
                  <div
                    className={`d-flex align-items-center justify-content-between bg-light-info p-2`}
                  >
                    <H4 attrH4={{ className: "text-muted m-0" }}>
                      Deactivate Selected Users?
                    </H4>
                    <Btn
                      attrBtn={{
                        color: "danger",
                        onClick: () => handleDeactivate(),
                      }}
                    >
                      Deactivate
                    </Btn>
                  </div>
                )}
                <DataTable
                  className="data-tables theme-scrollbar pt-4"
                  data={users}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelet}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default DataTablesContain;
